// fetchTracker.js
let activeFetchCount = 0;
const originalFetch = window.fetch;

window.fetch = function(input, init) {
  const url = typeof input === 'string' ? input : input.url;
  const isApiCall = url.includes('/api');  // Adjust if needed
 
  if (isApiCall) activeFetchCount++;

  return originalFetch(input, init).finally(() => {
    if (isApiCall) activeFetchCount--;
  });
};

export function getActiveFetchCount() {
  return activeFetchCount;
}
